import moment from 'moment-timezone';
import React from 'react';
import corporateHealthService from "services/corporate-health.service";
import v from 'voca'

export async function processHealthPass(hashId) {
  const {data: h} = await corporateHealthService.getHealthPassFromCode(hashId)
  
  const completedOnboarding = h.status === 'COMPLETED'&&!!(h.hash_id)&&!!(h.app_deep_link) ? {
    deep_link: h.app_deep_link,
    hash_id: h.hash_id,
  } : null

  return {
    completedOnboarding,
    primary_employee: h?.primary_employee,
    "healthPass": {
      company: h?.employee_reference?.affiliation?.label,
      logo:h?.employee_reference?.affiliation?.logoUrl
    },
    "linkIdForm": {
      "corporateIdNumber": h?.employee_reference.company_id??"",
      "identityType": h?.employee_reference.type??""
    },
    "medicalId": {
      "firstName": h?.employee_reference.first_name??"",
      "middleName": h?.employee_reference.middle_name??"",
      "lastName": h?.employee_reference.last_name??"",
      "birthDate": moment(h?.employee_reference?.birth_date).tz("Asia/Manila").toDate(),
      "gender": v.capitalize(h?.employee_reference?.gender??"", true),
      "eulaCheck": false,
    },
    dependentDetails: {
      primaryEmployeeId: h?.employee_reference?.primary_employee_id??"",
      dependentRelationship: h?.employee_reference?.dependent_type??"",
      isDependent: h?.employee_reference?.type==='DEPENDENT'
    },
    addressInfoForm: {
      civilStatus: h?.employee_reference?.civil_status?.name,
      barangay: h?.employee_reference?.residence?.barangay?.name,
      province: h?.employee_reference?.residence?.province?.name,
      region: h?.employee_reference?.residence?.region?.name,
      city: h?.employee_reference?.residence?.city?.name,
      street: h?.employee_reference?.residence?.street,
      building_info: h?.employee_reference?.residence?.building_info,
    },
    additionalInfo: {
      allergies: h?.employee_reference?.allergies.map(({allergy_id, id, ...p})=>{
        return {
          ...p,
          id: allergy_id??id
        }
      }),
      comorbidities: h?.employee_reference?.comorbidities.map(({comorbidity_id, id, ...p})=>{
        return {
          ...p,
          id: comorbidity_id??id
        }
      }),
    },
    "partnerId": h?.affiliation?.id
  }
}